// Inline two-step confirm for diamond purchases and refine: the first click turns the
// button into "Confirm 30 ◆" for a few seconds (ten for gems), a second click buys. No
// dialog, nothing covers the page; it falls back to the normal label on its own.
import { esc } from './fmt.ts';
import { iconUrl } from './assets.ts';

/** How long a button stays armed. */
export const CONFIRM_MS = 4000;
/** Spending or cashing out gems (real money) waits longer for the second click. */
export const CONFIRM_MONEY_MS = 10_000;

let armedKey = '';
let timer: ReturnType<typeof setTimeout> | undefined;
let rerender: () => void = () => {};
// The time left shows as a bar draining along the armed button's bottom edge (.btn.armed::after in
// style.css). It reads one CSS variable on the page root, so a redraw mid-wait keeps its place.
let armedAt = 0, armedMs = CONFIRM_MS;
let tick: ReturnType<typeof setInterval> | undefined;
function showLeft() {
  const left = armedKey ? Math.max(0, 1 - (performance.now() - armedAt) / armedMs) : 1;
  document.documentElement.style.setProperty('--armed-left', left.toFixed(3));
}
function stopTick() { clearInterval(tick); tick = undefined; }

export function bindConfirm(render: () => void) { rerender = render; }

/** Whether this button is waiting for its second click. */
export const isArmed = (key: string) => armedKey === key;

/** The label for a diamond purchase button: the normal label, or the confirm prompt while armed. */
export const confirmLabel = (key: string, label: string, price: number) => (isArmed(key) ? `Confirm ${price} ◆` : label);

/** The same label as button HTML: escaped, with ◆ drawn as our diamond icon instead of the text glyph. */
export const priceLabel = (key: string, label: string, price: number) => esc(confirmLabel(key, label, price)).replace(/◆/g, diamondImg());
export const diamondImg = () => `<img class="dia" src="${iconUrl('diamond')}" alt="diamonds">`;

/**
 * A click on a purchase button. Returns true when this click confirms (the
 * button was armed); otherwise arms it, redraws, and returns false.
 */
export function confirmClick(key: string, ms = CONFIRM_MS): boolean {
  clearTimeout(timer);
  if (armedKey === key) { armedKey = ''; stopTick(); return true; }
  armedKey = key; armedAt = performance.now(); armedMs = ms;
  timer = setTimeout(() => { if (armedKey === key) { armedKey = ''; stopTick(); rerender(); } }, ms);
  stopTick(); showLeft(); tick = setInterval(showLeft, 100);
  rerender();
  return false;
}

/** Drop any armed button (say, on leaving the page). */
export function disarm() { clearTimeout(timer); stopTick(); armedKey = ''; }
